import { render, staticRenderFns } from "./ReviewTaskDetail.vue?vue&type=template&id=3ac62ad8&scoped=true"
import script from "./ReviewTaskDetail.vue?vue&type=script&lang=js"
export * from "./ReviewTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewTaskDetail.vue?vue&type=style&index=0&id=3ac62ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac62ad8",
  null
  
)

export default component.exports